import React from 'react';
import './buttons.scss';

class ButtonSecondary extends React.Component {
  render() {
    const { buttonText, onClick, hasArrow, tabIndex, hasPlay, ariaHidden } =
      this.props;
    return (
      <button
        className="button-secondary"
        onClick={onClick}
        tabIndex={tabIndex}
        id="button-secondary"
        aria-hidden={ariaHidden}
      >
        {hasArrow && (
          <img className="img-arrow" alt="" src="images/dark-left-arrow.png" />
        )}
        <div className="button-text">{buttonText}</div>
        {hasPlay && <div className={hasPlay}></div>}
      </button>
    );
  }
}
export default ButtonSecondary;
